"use client";
import { createBaseComponents } from "@theme/shared/create-base-components.jsx";

const printStyles = {
  "header, nav, .sidebar, .MuiAppBar-root, .no-print": {
    display: "none !important",
  },
  ".print-header": {
    display: "block !important",
    marginBottom: "16px",
  },
  ".print-container": {
    margin: 0,
    padding: "0.5cm",
    width: "100% !important",
  },
  ".MuiIconButton-root": {
    display: "none !important",
  },
  ".MuiButton-root": {
    display: "none !important",
  },
};

export const createComponents = () =>
  createBaseComponents({
    buttonRadius: "6px",
    cardRadius: 5,
    filledBorderWidth: 0.5,
    printStyles,
  });
